import { BsPinAngleFill } from "react-icons/bs";
import PostMetadata from "../../../../components/GeneralPostTag/PostMetadata";
import { formatPostDate } from "../../../../Utils/StayUpToDate/RenderComponent";
import "../../../../components/FeedPost/PlatformPosts/NewsletterPost/NewsletterPost.css";

export const NoMediaPost = ({
  post,
  type,
  label,
  showDate = true,
  useCaptionFallback = false,
  className,
  showMeta = true,
  showMenu = false,
  style,
  isPinned,
}: any) => {
  const title = useCaptionFallback ? (post?.caption || label) : label;
  const shouldShowDate = showDate && post?.post_date;
  const cardClass = className || "newsletter-media-carousel h-250 no-media-url";

  const renderPinnedBadge = () =>
    isPinned ? (
      <div className="pinned-badge" aria-label="Pinned post" style={{right:"4px"}}>
              <BsPinAngleFill />

      </div>
    ) : null;


  return (
    <div style={{ position: "relative" }}>
      {renderPinnedBadge()}
      {showMeta && <PostMetadata post={post} type={type} showMenu={showMenu} />}
      <div className={cardClass} style={style}>
        <h4 className="newsletter-label">{title}</h4>
        {shouldShowDate && (
          <h4 className="mt-7 date" style={{ color: "#ffffff" }}>
            {formatPostDate(post.post_date)}
          </h4>
        )}
      </div>
    </div>
  );
};
